// src/App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "leaflet/dist/leaflet.css";

import Home from "./pages/Home";
import AboutOverview from "./pages/AboutOverview";
import AboutGenetics from "./pages/AboutGenetics";
import AboutCare from "./pages/AboutCare";
import AboutSymptoms from "./pages/AboutSymptoms";
import AboutPrevention from "./pages/AboutPrevention";
import TestingLocator from "./pages/TestingLocator";
import Quiz from "./pages/Quiz";
import Resources from "./pages/Resources";
import Support from "./pages/Support";
import Contact from "./pages/Contact";
import BloodDonation from "./pages/BloodDonation";
import NotFound from "./pages/NotFound";

export default function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white text-slate-800">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route index element={<Home />} />

            {/* About split */}
            <Route path="/about" element={<AboutOverview />} />
            <Route path="/about/genetics" element={<AboutGenetics />} />
            <Route path="/about/care" element={<AboutCare />} />
            <Route path="/about/symptoms" element={<AboutSymptoms />} />
            <Route path="/about/prevention" element={<AboutPrevention />} />

            <Route path="/testing-locator" element={<TestingLocator />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/support" element={<Support />} />
            <Route path="/contact" element={<Contact />} />

            {/* New */}
            <Route path="/blood-donation" element={<BloodDonation />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
